const mlsIsZip = ( value: string ): boolean => {
    const zipRegex: RegExp = /^\d{5}(-\d{4})?$/;
    return zipRegex.test( value.trim() );
}
export default mlsIsZip;